import { render, staticRenderFns } from "./Priority.vue?vue&type=template&id=2f95b708&"
import script from "./Priority.vue?vue&type=script&lang=js&"
export * from "./Priority.vue?vue&type=script&lang=js&"
import style0 from "./Priority.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports